import { Fragment, useEffect, useRef, useState } from "react";
import { isValidArray } from "../../../Layout/Common/common";
import { FilterPopup } from "../../../Layout/Common/PopUp/filterPopup";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { sortbyJson } from "../../../constants";
import { FilterManufacuture } from "./filterManufacuture";

export const FilterConatiner = ({ params, filteredData, handleFilterEvent, showSortby }) => {
  const [filter, setFilter] = useState(null);
  const [filterAttribute, setFilterAttribute] = useState(null);
  const [filterLength, setFilterLength] = useState(0);
  const childRef = useRef();

  useEffect(() => {
    if (params) {
      setFilterAttribute(params);
    }
  }, [params]);

  const CalculateFilterLength = (val) => {
    setFilterLength(val);
  };

  const handleFilterProduct = (val) => {
    handleFilterEvent(val);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleClearFilter = () => {
    setFilter(null);
    handleFilterEvent([]);
    childRef.current.clearfilter();
  };
  return (
    <Fragment>
      <div className="col-lg-12 mt-2">
        <div className="proFilters-listing filterListing">
          <h5>Filters</h5>
          {/* Sortby and Filter list */}
          <div className="categoryFilter">
            <FilterManufacuture />
            <FilterPopup
              callbackFunction={CalculateFilterLength}
              handleFilterProduct={handleFilterProduct}
              clearFilter={handleClearFilter}
              filterItems={filterAttribute}
              ref={childRef}
            />
          </div>
        </div>
      </div>
      <div className="productFilter-clear productFilterClear">
        <p class="text-decoration-underline" style={{ width: "fit-content" }} onClick={handleClearFilter}>
          Clear Filter
        </p>
      </div>
    </Fragment>
  );
};
